import { get } from 'lodash'

import { formatDate } from '../../helpers/formatters'
import { ChildrenDocument, ChildrenDocumentAttachment, ChildrenDocumentMissing } from '../../models/document'
import { midGray } from '../../theme/colors'
import { TextRight } from '../Base/Base'
import { Text } from '../Text/Text'
import { DocumentListGrid } from './DocumentList'
import { DocumentRowInfoStatus } from './DocumentRowInfoStatus'

interface DocumentRowAttachmentsVersionItemProps {
  document: ChildrenDocument | ChildrenDocumentMissing
  attachments: ChildrenDocumentAttachment[]
  onDocumentOpen?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[]
  ) => React.ReactNode
  renderDocumentAction?: (
    document: ChildrenDocument | ChildrenDocumentMissing,
    attachments?: ChildrenDocumentAttachment[],
    refetchDocuments?: () => Promise<any>
  ) => React.ReactNode
}

export function DocumentRowAttachmentsVersionItem({
  document,
  attachments,
  onDocumentOpen,
  renderDocumentAction,
}: DocumentRowAttachmentsVersionItemProps) {
  const effectiveDateSource = "metadata['dateEffective']"
  const expiredDateSource = "metadata['dateExpired']"
  const attachment = attachments[0]

  return (
    <DocumentListGrid
      isItem
      isSmall
      onClick={onDocumentOpen ? () => onDocumentOpen?.(document, attachments) : undefined}
    >
      <Text variant="label2" fontColor={midGray} ml={3.6}>
        {attachment.originalFilename}
      </Text>

      <div>
        <DocumentRowInfoStatus item={attachment} />
      </div>

      <Text variant="paragraph1" fontColor={midGray}>
        {formatDateWithFallback(get(attachment, effectiveDateSource))}
      </Text>

      <Text variant="paragraph1" fontColor={midGray}>
        {formatDateWithFallback(get(attachment, expiredDateSource))}
      </Text>

      <Text variant="paragraph1" fontColor={midGray}></Text>

      <TextRight className="actions">{renderDocumentAction?.(document, attachments)}</TextRight>
    </DocumentListGrid>
  )
}

function formatDateWithFallback(date?: string) {
  if (!date) return '-'
  return formatDate(date)
}
